import { useEffect, useRef } from "react";

// Interval polling that slows or pauses while the tab is hidden, and refreshes as soon as it is visible again.
// hiddenMs: null = pause while hidden; a number = keep polling at that slower rate.
export function usePoll(fn, ms, { hiddenMs = null, enabled = true, immediate = true } = {}) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled || !ms) return undefined;
    let timer = null;
    const run = () => ref.current();
    const schedule = () => {
      clearInterval(timer);
      const hidden = document.visibilityState === "hidden";
      const every = hidden ? hiddenMs : ms;
      timer = every ? setInterval(run, every) : null;
    };
    const onVis = () => {
      if (document.visibilityState === "visible") run();
      schedule();
    };
    if (immediate) run();
    schedule();
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", onVis); };
  }, [ms, hiddenMs, enabled, immediate]);
}
